module.exports = __webpack_public_path__ + "static/img/northFace2.158ed40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/northFace2.png
// module id = fApn
// module chunks = 2